{
  "title": "Aura of Life",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level abjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "Self (30-foot radius)",
  "components": "V",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Life-preserving energy radiates from you in an aura with a 30-foot radius. Until the spell ends, the aura moves with you, centered on you. Each non-hostile creature in the aura (including you) has resistance to necrotic damage, and its hit point maximum can’t be reduced. In addition, a non-hostile, living creature regains 1 hit point when it starts its turn in the aura with 0 hit points."
  ],
  "spellLists": ["cleric", "paladin"]
}
